/* eslint-disable array-callback-return */
import React, { useState, useEffect, useMemo } from "react";
import ProductCard from "../ProductCard";
import UseFetch from "../../hook/useFetch";
import {
  Button,
  Pagination,
  Menu,
  MenuItem,
  Fade,
} from "@mui/material";
import "./style.css";

import SortIcon from "@mui/icons-material/Sort";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

export default function ProductBrand() {
  const { data, loading } = UseFetch(
    "https://ebuy-backend-two.vercel.app/api/article"
  );

  const produits = useMemo(() => {
    return Array.from(data).reverse();
  }, [data]);

  let pathName = window.location.pathname;
  let pathe = pathName.replace(/%20/g, " ");
  let brand = pathe.split("/")[1];

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(6);

  // ✅ Même logique que AllProducts
  const [sortBy, setSortBy] = useState("newest");

  // ✅ Menu state
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  // ✅ Open menu
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // ✅ Close menu
  const handleClose = (sortValue) => {
    if (sortValue) setSortBy(sortValue);
    setAnchorEl(null);
  };

  // ✅ Responsive
  useEffect(() => {
    const updateItemsPerPage = () => {
      const windowWidth = window.innerWidth;

      if (windowWidth >= 1200) {
        setItemsPerPage(12);
      } else if (windowWidth >= 700) {
        setItemsPerPage(12);
      } else {
        setItemsPerPage(8);
      }
    };

    updateItemsPerPage();

    window.addEventListener("resize", updateItemsPerPage);

    return () => {
      window.removeEventListener("resize", updateItemsPerPage);
    };
  }, []);

  // ✅ Filter brand
  const filteredProducts = produits.filter((produit) => {
    if (brand) {
      return brand === produit.brand;
    } else {
      return true;
    }
  });

  // ✅ Pagination
  const totalPages = Math.ceil(
    filteredProducts.length / itemsPerPage
  );

  // ✅ Sort products
  const sortedProducts = useMemo(() => {
    let result = [...filteredProducts];

    if (sortBy === "priceAsc") {
      result.sort((a, b) => a.prix - b.prix);
    } else if (sortBy === "priceDesc") {
      result.sort((a, b) => b.prix - a.prix);
    }

    // newest => garde ordre original reverse()

    return result;
  }, [filteredProducts, sortBy]);

  // ✅ Change page
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);

    window.scrollTo(0, 0);

    const searchParams = new URLSearchParams(
      window.location.search
    );

    searchParams.set("page", newPage.toString());

    const newUrl = `${window.location.pathname}?${searchParams.toString()}`;

    window.history.pushState({}, "", newUrl);
  };

  // ✅ Current products
  const currentCards = sortedProducts.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return loading ? (
    <div className="loaderContainer">
      <div className="loader"></div>
    </div>
  ) : (
    <div>
      {/* ✅ SAME FILTER HEADER */}
      <div className="filter-header">
        <Button
          id="sort-button"
          aria-controls={open ? "sort-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          variant="text"
          disableElevation
          onClick={handleClick}
          startIcon={<SortIcon />}
          endIcon={<KeyboardArrowDownIcon />}
          className="modern-sort-btn"
        >
          {sortBy === "priceAsc"
            ? "Prix croissant"
            : sortBy === "priceDesc"
            ? "Prix décroissant"
            : "Nouveautés"}
        </Button>

        <Menu
          id="sort-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={() => handleClose()}
          TransitionComponent={Fade}
          PaperProps={{
            elevation: 0,
            className: "modern-menu-paper",
          }}
        >
          <MenuItem
            onClick={() => handleClose("newest")}
            selected={sortBy === "newest"}
          >
            Nouveautés
          </MenuItem>

          <MenuItem
            onClick={() => handleClose("priceAsc")}
            selected={sortBy === "priceAsc"}
          >
            Prix croissant
          </MenuItem>

          <MenuItem
            onClick={() => handleClose("priceDesc")}
            selected={sortBy === "priceDesc"}
          >
            Prix décroissant
          </MenuItem>
        </Menu>
      </div>

      {/* ✅ TOP PAGINATION */}
      {totalPages > 1 && (
        <div className="pagination">
          <Pagination
            count={totalPages}
            page={currentPage}
            shape="rounded"
            variant="outlined"
            onChange={(event, newPage) =>
              handlePageChange(newPage)
            }
            color="warning"
            size="small"
          />
        </div>
      )}

      {/* ✅ PRODUCTS */}
      <div className="productmarquePages">
        {currentCards.map((produit, index) => (
          <ProductCard
            key={produit._id || produit.article + index}
            index={index}
            {...produit}
            reference={produit.ref}
          />
        ))}
      </div>

      {/* ✅ BOTTOM PAGINATION */}
      {totalPages > 1 && (
        <div className="pagination">
          <Pagination
            count={totalPages}
            page={currentPage}
            shape="rounded"
            variant="outlined"
            onChange={(event, newPage) =>
              handlePageChange(newPage)
            }
            color="warning"
            size="small"
          />
        </div>
      )}
    </div>
  );
}